// Fendas de Noxara (dungeons): o porão de tortura. Tier pelo level, entradas do dia e entrada com a party.
// Mapa: Cela de Espera (entrada) e o Matadouro, uma sala só com 21 criaturas que agram de qualquer ponto;
// quando a sala é limpa, o Guardião da Fenda surge no altar de sangue.
import { useState } from 'preact/hooks';
import type { Outfit } from '../../../../shared/src/protocol';
import { RIFT_DMG_MULT, RIFT_HP_MULT, RIFT_TIME_MS, riftLevels } from '../../../../shared/src/game/rift';
import { OutfitImage } from '../../screens/Characters';

export interface RiftState { left: number; total: number; tier: number; pool: string[]; gold: number; boss?: string }

const n = (v: number) => v.toLocaleString('pt-BR');
const ROMAN = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX'];
const roman = (t: number) => ROMAN[t] ?? String(t);

export function Rift(props: { st: RiftState | null; inCity: boolean; inParty: boolean; leader: boolean; outfitOf: (n: string) => Outfit | undefined; onEnter: () => void }) {
  const [help, setHelp] = useState(false);
  const st = props.st;
  if (!st) return <p class="muted">Carregando...</p>;
  const minutes = Math.round(RIFT_TIME_MS / 60_000);
  const [lo, hi] = riftLevels(st.tier);
  const blocked = !st.left || !props.inCity || (props.inParty && !props.leader);
  const why = !props.inCity ? 'Volte para a cidade para descer ao porão.' : !st.left ? 'Suas entradas de hoje acabaram. Elas voltam à meia-noite.' : props.inParty && !props.leader ? 'Só o líder da party abre a fenda.' : '';
  const label = !props.inCity ? 'Volte para a cidade' : !st.left ? 'Sem entradas hoje' : props.inParty ? (props.leader ? 'Abrir a fenda com a party' : 'Só o líder abre a fenda') : 'Entrar sozinho na fenda';

  return (
    <div class={'rf' + (blocked ? ' rf-blocked' : ' rf-ready')}>
      {/* cabeçalho: a porta do porão */}
      <div class="rf-head">
        <div class="rf-drips"><i /><i /><i /><i /><i /></div>
        <div class="rf-seal" title={`Tier ${st.tier}`}><small>TIER</small><b>{roman(st.tier)}</b></div>
        <div class="rf-head-txt">
          <div class="rf-title">Fendas de Noxara <button class="rf-help" onClick={() => setHelp(!help)} title="Como funciona">?</button></div>
          <div class="rf-sub">O porão de tortura. Alguém quer jogar um jogo.</div>
          <div class="rf-tags">
            <span>Criaturas de hunts level {lo}–{hi}</span>
            <span>+{Math.round((RIFT_HP_MULT - 1) * 100)}% vida · +{Math.round((RIFT_DMG_MULT - 1) * 100)}% dano</span>
            <span>Sem respawn</span>
          </div>
        </div>
      </div>

      {/* números que importam */}
      <div class="rf-stats">
        <div class={'rf-stat' + (st.left ? '' : ' empty')} title="Entradas de hoje (voltam à meia-noite)">
          <small>Entradas hoje</small>
          <b>{st.left}<em>/{st.total}</em></b>
          <span class="rf-pips">{Array.from({ length: st.total }, (_, i) => <i key={i} class={i < st.left ? 'on' : ''} />)}</span>
        </div>
        <div class="rf-stat" title="O tier sobe a cada 50 levels; na party vale o maior level">
          <small>Seu tier</small><b>{st.tier}</b><span>sobe a cada 50 levels</span>
        </div>
        <div class="rf-stat clock" title="Tempo para limpar o Matadouro e matar o Guardião">
          <small>Relógio</small><b>{minutes}<em>min</em></b><span>o tempo corre</span>
        </div>
        <div class="rf-stat prize" title="Recompensa ao derrotar o Guardião (vai para o banco)">
          <small>Recompensa</small><b>{n(st.gold)}<em>gp</em></b><span>+ equipamento + fragmento</span>
        </div>
      </div>

      {(help || st.left === st.total) && (
        <div class="rf-steps">
          <div><i>⛓️</i><b>1. Cela de Espera</b><small>Você {props.inParty ? 'e a party descem' : 'desce'} ao porão. Na party, só o líder abre e cada um gasta uma entrada.</small></div>
          <div><i>🔪</i><b>2. O Matadouro</b><small>Uma sala só, 21 criaturas do seu tier. Ao primeiro passo, todas vêm atrás de você.</small></div>
          <div><i>🩸</i><b>3. Altar de sangue</b><small>Sala limpa: o Guardião da Fenda surge no altar. É a criatura mais forte do tier, muito mais resistente.</small></div>
          <div><i>⏳</i><b>4. Antes do relógio</b><small>Mate o Guardião em {minutes} minutos e leve gold, um equipamento (Raro ou melhor) e um fragmento.</small></div>
        </div>
      )}

      {/* as criaturas que podem estar acorrentadas lá embaixo */}
      <div class="rf-sec">Quem espera no Matadouro <small>· sorteadas do tier {st.tier}</small></div>
      <div class="rf-pool">
        {st.pool.map((name) => {
          const o = props.outfitOf(name);
          return (
            <div key={name} class="rf-mon" title={name}>
              <span class="rf-mon-img">{o ? <OutfitImage outfit={o} /> : <i>?</i>}</span>
              <small>{name}</small>
            </div>
          );
        })}
        {!st.pool.length && <p class="muted small">Nenhuma criatura neste tier ainda.</p>}
      </div>

      {/* o Guardião e a recompensa */}
      <div class="rf-altar">
        <div class="rf-boss" title="O Guardião é a criatura mais forte do tier sorteado">
          {st.boss && props.outfitOf(st.boss) ? <span class="rf-boss-sil rf-boss-img"><OutfitImage outfit={props.outfitOf(st.boss)!} /></span> : <span class="rf-boss-sil">?</span>}
        </div>
        <div class="rf-altar-txt">
          <b>Guardião da Fenda{st.boss ? ` (${st.boss})` : ''}</b>
          <small>Desperta no altar de sangue quando o Matadouro fica em silêncio. Mais forte que tudo o que veio antes.</small>
          <div class="rf-loot">
            <span><b class="rf-gold">{n(st.gold)}</b> gp</span>
            <span>⚔️ Equipamento do tier <b class="rf-rare">Raro+</b></span>
            <span>💠 1 fragmento de proteção</span>
          </div>
        </div>
      </div>

      {/* porta: bloqueada ou pronta */}
      <div class="rf-door">
        {why ? <span class="rf-why">🔒 {why}</span> : <span class="rf-go">A porta está destrancada. {props.inParty ? 'Sua party vai junto.' : 'Você vai sozinho.'}</span>}
        <button class="tb-button green rf-enter" disabled={blocked} onClick={props.onEnter}>{label}</button>
      </div>
    </div>
  );
}
